import React from "react";
import { useLenis } from "../hooks/useLenis";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import StatsCounter from "../components/StatsCounter";
import ManifestoSection from "../components/ManifestoSection";
import AboutSection from "../components/AboutSection";
import BookSection from "../components/BookSection";
import ReviewsSection from "../components/ReviewsSection";
import Marquee from "../components/Marquee";
import GallerySection from "../components/GallerySection";
import VideosSection from "../components/VideosSection";
import MediaSection from "../components/MediaSection";
import BlogSection from "../components/BlogSection";
import Newsletter from "../components/Newsletter";
import ContactSection from "../components/ContactSection";
import FloatingButtons from "../components/FloatingButtons";
import Footer from "../components/Footer";

export default function HomePage() {
  useLenis();

  return (
    <div className="App">
      <Header />
      <main id="home">
        <HeroSection />
        <StatsCounter />
        <Marquee />
        <ManifestoSection />
        <AboutSection />
        <BookSection />
        <ReviewsSection />
        <GallerySection />
        <VideosSection />
        <MediaSection />
        <BlogSection />
        <Newsletter />
        <ContactSection />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
